import E from "../../shared-lib/logger.js";
import { MUST_BE_CARD_WARNING_SUFFIX as Q } from "../common/constants.js";
import r from "../managers/braze-instance.js";
import G from "./card-manager-factory.js";
import { Card } from "./models/index.js";
export function logContentCardClick(o) {
  return !!r.rr() && (o instanceof Card ? G.ea().logClick(o).W : (E.error("card " + Q), !1));
}